var _style, _path, _path2, _path3, _circle, _circle2, _circle3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileBroadcastIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mobile_broadcast_icon_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 100 50",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".mobile_broadcast_icon_svg__st2{fill:none;stroke:#000;stroke-width:2;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4 18.3l11.7 6.1c.4.2.4.8 0 1.1l-11.7 6.1c-.4.2-.9-.1-.9-.5V18.8c0-.5.5-.8.9-.5z",
    fill: "#070404",
    stroke: "#000",
    strokeWidth: 0.359,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90 46.6H11.4c-3 0-5.5-2.4-5.5-5.5V8.4c0-3 2.4-5.5 5.5-5.5H90c3 0 5.5 2.4 5.5 5.5v32.8c-.1 3-2.5 5.4-5.5 5.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "mobile_broadcast_icon_svg__st2",
    d: "M81.2 46.5V2.8M20.3 46.5V2.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "mobile_broadcast_icon_svg__st2",
    cx: 13.2,
    cy: 24.8,
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.3,
    cy: 18.2,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 24.8,
    r: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 28.9h-.3c-.6 0-1.1-.5-1.1-1.1V22c0-.6.5-1.1 1.1-1.1h.3c.6 0 1.1.5 1.1 1.1v5.8c0 .6-.5 1.1-1.1 1.1z"
  })));
}
export default __webpack_public_path__ + "bccab1e554d998d5f3aa8097aefccc60.svg";
export { SvgMobileBroadcastIcon as ReactComponent };